import { store } from '../index';
import { CLEAR_STATE_ACTION_TYPE } from './actionTypes';

export const clearStore = () => {
  store.dispatch({ type: CLEAR_STATE_ACTION_TYPE });
};
